"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistedInstallerHeader = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const common_1 = require("../../../common");
const AssistedInstallerHeader = () => {
    return (react_1.default.createElement(react_core_1.TextContent, null,
        react_1.default.createElement(react_core_1.Text, { component: "h1", className: "pf-v5-u-display-inline" }, "Install OpenShift with the Assisted Installer"),
        react_1.default.createElement(react_core_1.Split, { hasGutter: true },
            react_1.default.createElement(react_core_1.SplitItem, null,
                react_1.default.createElement(common_1.ExternalLink, { href: common_1.ASSISTED_INSTALLER_DOCUMENTATION_LINK }, "Assisted Installer documentation")),
            common_1.isInOcm && (react_1.default.createElement(react_core_1.SplitItem, null,
                react_1.default.createElement(react_core_1.Text, { component: "a", "data-testid": "whats-new-link" }, "What's new in Assisted Installer?"))))));
};
exports.AssistedInstallerHeader = AssistedInstallerHeader;
//# sourceMappingURL=AssistedInstallerHeader.js.map